export const ENDPOINTS = {
  quickEntries: 'v1/quick-entries',
  quickEntriesById: 'v1/quick-entries/:id',
  quickEntryTypes: 'v1/quick-entries/types'
};
